import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { AppProviders } from './app/providers';
import { routes } from './routes/routes';

const router = createBrowserRouter(routes);

export function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
